import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { currentBudgetSelector } from "../selectors/current-budget/currentBudgetSelector";
import { RootState } from "../../store";
import { enqueueSnackbarErrorAlert } from "../../../components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { formatThresholds } from "@/components/pages/budgets-and-alerts/components/drawer/budget-alert-create-edit-drawer/components/budgets/components/create-budget/utils/helpers/formatThresholds";

export const updateBudgetFromCurrentThunk = createAsyncThunk(
  "budgets/updateBudgetFromCurrent",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const { patchUsersMeOrganisationsCurrentBudgetsByBudgetId } =
      cloudChiprApi.endpoints;

    const currentBudget = currentBudgetSelector(state);

    if (!currentBudget?.id) {
      return;
    }

    const filterTree =
      currentBudget.basedOn === "filterTree"
        ? currentBudget.body.filter_tree
        : null;
    const viewId =
      currentBudget.basedOn === "viewId" ? currentBudget.body.view_id : null;

    try {
      await dispatch(
        patchUsersMeOrganisationsCurrentBudgetsByBudgetId.initiate({
          "budget-id": currentBudget.id,
          body: {
            name: currentBudget.body.name,
            notifications: currentBudget.body.notifications ?? null,
            thresholds: formatThresholds(currentBudget.body.thresholds),
            amount: currentBudget.body.amount,
            planned_amounts: currentBudget.body.planned_amounts,
            email_to: currentBudget.body.email_to,
            view_id: viewId,
            filter_tree: filterTree,
            receive_updates: currentBudget.body.receive_updates,
          },
        }),
      ).unwrap();

      enqueueSnackbar(`${currentBudget.body.name} Budget updated!`, {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "success" },
      });

      return "success";
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
      return "error";
    }
  },
);
